<div class="row mx-0 mt-4">
  <div class="col-lg-12">
    <nb-card class="spreadsheet-card-wrapper">
      <nb-card-body class="spreadsheet p-0">
        <!-- Header -->
        <div class="row m-0 header-container">
          <div class="col-lg-9">
            {{ 
              "In the spreadsheet, {projectsNb} packages of work for an expected annual gain of {kwhSavings} MWh, or {co2Savings} t CO2 avoided" | translate: {
                projectsNb: projectsNb,
                kwhSavings: kwhSavings,
                co2Savings: co2Savings
              } 
            }}
          </div>
          <!-- Filters management -->
          <div class="col-lg-3 px-0">
            <app-table-filter [filtersNb]="filtersNb" tableType="project"></app-table-filter>
          </div>
      </div>
      <!-- Spreadsheet -->
      <div style="height: 720px">
        <nb-card class="spreadsheet-card h-100">
          @if (gridOptions) {
            <ag-grid-angular
              class="ag-theme-balham ag-grid-kpi"
              [gridOptions]="gridOptions"
            >
            </ag-grid-angular>
          }
        </nb-card>
      </div>
    </nb-card-body>
  </nb-card>
</div>
</div>
